var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99762 10.9948C8.75774 10.9948 10.9952 8.75725 10.9952 5.99714C10.9952 3.23702 8.75774 0.999512 5.99762 0.999512C3.23751 0.999512 1 3.23702 1 5.99714C1 8.75725 3.23751 10.9948 5.99762 10.9948Z",
    stroke: "#9CA3AF",
    strokeWidth: 0.999525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 2.99854V5.99711L7.9971 6.99664",
    stroke: "#9CA3AF",
    strokeWidth: 0.999525,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9943,
    height: 11.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.c64628ed8ee1d74c80ea93a5120e3602.svg";
export { ForwardRef as ReactComponent };